import './service-cards.css'

const services = [
    {
        title: "Bathroom Renovations",
        subtitle: "Complete design and high-quality builds. Elevate your daily routine with bespoke finishes.",
        src: "/static/images/Interior-4U-Bathroom-Cover.webp",
        alt: "Interior 4U Modern bathroom"
    },
    {
        title: "Kitchen Renovations",
        subtitle: "The heart of your home, reimagined. Custom layouts and premium finishes for modern living.",
        src: "/static/images/Interior-4U-Kitchen-Cover.webp",
        alt: "Interior 4U Contemporary kitchen"
    },
    {
        title: "Wardrobes & Storage",
        subtitle: "Smart, custom IKEA storage solutions. Get a premium, built-in look with expert installation.",
        src: "/static/images/Interior-4U-Wardrobe-Cover.webp",
        alt: "Interior 4U Wardrobe storage"
    },
    {
        title: "Design Services",
        subtitle: "Expert curation and sourcing. We partner with top suppliers to find products that fit your needs.",
        src: "/static/images/Interior-4U-Design-Cover.webp",
        alt: "Interior 4U Design Service"
    }
];

const ServiceCards = () => {
    return (

        <div className="service-card-grid">
            {services.map((service, index) => (
                <div key={index} className="service-card">
                    <div className="img-wrapper">
                        <img className="img-wrapper-img" src={service.src} alt={service.alt} />
                    </div>
                    <h3 className="card-h3">{service.title}</h3>
                    <p className="card-p">{service.subtitle}</p>
                </div>
            ))}
        </div>


    )
}
export default ServiceCards;